import { TabsContent as TabContentPrimitive } from '@radix-ui/react-tabs'
import React from 'react'

interface TabContentProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode
  name: string
}

export function TabContent ({ children, name, ...props }: TabContentProps) {
  return (
    <TabContentPrimitive
      {...props}
      className='rounded-r-lg flex flex-col invisible data-[state=active]:visible space-y-2 p-4 outline outline-2 -outline-offset-1 outline-transparent focus-visible:outline-thatch-500 [grid-area:1/2]'
      forceMount
      value={name}
    >
      {children}
    </TabContentPrimitive>
  )
}

TabContent.displayName = 'FiltersDropdown.TabContent'
